import { IAccordionData } from "@/models/IAccordionData";
import s1Icon1 from "../../assets/icons/capabilities-pms-s1-1.png";
import s1Icon2 from "../../assets/icons/capabilities-pms-s1-2.png";
import s2Icon1 from "../../assets/icons/capabilities-pms-s2-1.png";
import s3Icon1 from "../../assets/icons/capabilities-pms-s3-1.png";
import s3Icon2 from "../../assets/icons/capabilities-pms-s3-2.png";

import CapabilitiesTextContainer from "../../components/capabilitiesTextContainer";
import AccordionWrapper from "../../components/accordionWrapper";

const accordionDataRaw = [
  {
    header: "Quality",
    descriptionHeader: "",
    description: "",
    data: [
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon1}
            alt="An outline of someone's head with a gear on their head"
            className="h-28"
          />
        ),
        header: "Lilly ExploR&D Offerings",
        data: [
          "Independent Quality Management System to oversee Investigational New Drug (IND)/Clinical Trial Application (CTA)-enabling preclinical and toxicology work, study drug manufacturing and clinical execution of Phase I and II Studies",
          "Consult on global requirements for Good X Practice (GxP) compliance, electronic signatures, Electronic Common Technical Document (eCTD) submissions, and privacy standards",
          "Standard Operating Procedures (SOPs) designed for early phase development from target identification to clinical proof of concept",
          "Support to oversee drug manufacturing, release, and distribution; nonclinical study execution; clinical data acquisition and analysis; clinical study execution including bioanalytical work; and maintenance of Trial Master File",
          "Support to audit new vendors and oversee qualification activities",
          "Support to conduct Quality Investigations, provide Corrective and Preventative Action (CAPA) support, and ensure Inspection Readiness",
        ],
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s1Icon2}
            alt="A document with a pencil and a test tube"
            className="h-28"
          />
        ),
        header: "The Final Result",
        data: [
          "Support for product integrity and reliability through adherence to globally accepted quality standards",
          "Support the delivery of high-quality data packages that enable you to transition seamlessly to the next phase of development",
        ],
      },
    ],
  },
  {
    header: "Program Management",
    description:
      "The Lilly ExploR&D Clinical Program Lead manages all ExploR&D activities across the entire development cycle from collaborative design to data generation and decision-making",
    data: [
      {
        headerSection: "",
        icon: <></>,
        header: "Who We Are",
        data: [
          "A team of program managers spanning discovery and development through commercialization",
        ],
      },
      {
        headerSection: "",
        icon: <></>,
        header: "What We Do",
        data: [
          "Coordinate Toxicology, Pharmacokinetic-Pharmacodynamic (PKPD), Chemistry, Manufacturing & Control (CMC), Medical, Clinical Operations and Regulatory",
          "Integrate target biology, risk profile and disease benchmark modeling across a variety of relevant clinical options",
          "Support Integrated Development Plans (IDPs) to merge clinical forecasts and operational workstreams",
          "Serve as the primary point of contact to manage the journey from design and data generation to decision-making",
        ],
      },
      {
        headerSection: "",
        icon: <></>,
        header: "Our Work Output",
        data: ["Collaborative and strategically aligned development plans"],
      },
    ],
  },
  {
    header: "Procurement & Sourcing",
    descriptionHeader: "",
    description: "Finding the vendors to execute drug development plans",
    description2: "",
    data: [
      {
        headerSection: "",
        icon: <img src={s3Icon1} alt="A hexagon" className="h-28" />,
        header: "Optimizing Vendor Use",
        data: [
          "Request for information tools to help survey prospective vendors",
          "Standardized request for proposals",
          "Host bid defense meetings for larger projects to allow client to meet vendors before project award",
        ],
      },
      {
        headerSection: "",
        icon: (
          <img
            src={s3Icon2}
            alt="A magnifying glass being used on a document"
            className="h-28"
          />
        ),
        header: "Optimizing Clinical Finances",
        data: [
          "Pricing benchmarks to help clients scenario plan and determine potential funding needs",
          "Invoice review and validation",
        ],
      },
    ],
  },
];
const ProgramManagementAndSupport = (props: {
  accordionOpenHeader: string;
  setAccordionOpenHeader: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const accordionData: IAccordionData[] = [
    //Quality
    {
      header: accordionDataRaw[0].header,
      body: (
        <div className="px-4 py-4">
          {/* <div className="text-xl font-light max-w-[40rem]">
            <span className="font-semibold">
              {accordionDataRaw[0].descriptionHeader}
            </span>
            &nbsp;
            {accordionDataRaw[0].description}
          </div> */}
          <div className="my-8 grid xl:grid-cols-4 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[0].data.map((el, index) => (
              <div
                className={`h-full ${index === 0 ? "xl:col-span-3 col-span-1" : ""}`}
              >
                <div className="h-full">
                  <CapabilitiesTextContainer>
                    <div>
                      <div className="w-full mt-2 mb-4 flex justify-center">
                        {el.icon}
                      </div>
                      <div className="font-medium mb-2">{el.header}</div>

                      <div
                        className={`grid ${index === 0 ? "lg:grid-cols-2" : ""} gap-4`}
                      >
                        <ul className="px-4">
                          {Array.isArray(el.data) &&
                            el.data.map((point, index2) => (
                              <>
                                {(index2 % 2 === 0 || index2 === 5) && (
                                  <li className="py-1">{point}</li>
                                )}
                              </>
                            ))}
                        </ul>
                        <ul className="px-4">
                          {Array.isArray(el.data) &&
                            el.data.map((point, index2) => (
                              <>
                                {index2 % 2 !== 0 && index2 !== 5 && (
                                  <li className="py-1">{point}</li>
                                )}
                              </>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </CapabilitiesTextContainer>
                </div>
              </div>
            ))}
          </div>
        </div>
      ),
    },
    //Procurement & Sourcing
    {
      header: accordionDataRaw[2].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light max-w-[40rem]">
            <span className="font-semibold">
              {accordionDataRaw[2].descriptionHeader}
            </span>
            &nbsp;{accordionDataRaw[2].description}
          </div>
          <div className="mt-4 text-xl font-light max-w-[40rem]">
            {accordionDataRaw[2].description2}
          </div>
          <div className="my-8 grid xl:grid-cols-2 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            {accordionDataRaw[2].data.map((el, index) => (
              <div className="h-full">
                <CapabilitiesTextContainer>
                  <div>
                    <div className="w-full mt-2 mb-4 flex justify-center">
                      {el.icon}
                    </div>
                    <div className="font-medium mb-2">{el.header}</div>
                    <ul className="px-4">
                      {Array.isArray(el.data) &&
                        el.data.map((point) => (
                          <li className="py-1">{point}</li>
                        ))}
                    </ul>
                  </div>
                </CapabilitiesTextContainer>
              </div>
            ))}
          </div>
        </div>
      ),
    },
    //Program Management
    {
      header: accordionDataRaw[1].header,
      body: (
        <div className="px-4 py-4">
          <div className="text-xl font-light max-w-[40rem]">
            {accordionDataRaw[1].description}
          </div>
          <div className="my-8 grid xl:grid-cols-2 grid-cols-1 gap-4 xl:gap-2 items-center h-full">
            <div className="flex flex-col gap-4">
              {accordionDataRaw[1].data.map((el, index) => (
                <div className="h-full">
                  <CapabilitiesTextContainer>
                    <div>
                      <div className="font-medium mb-2">{el.header}</div>
                      <ul className="px-4">
                        {Array.isArray(el.data) &&
                          el.data.map((point) => (
                            <li className="py-1">{point}</li>
                          ))}
                      </ul>
                    </div>
                  </CapabilitiesTextContainer>
                </div>
              ))}
            </div>
            <div className="w-full h-full flex justify-center">
              <img
                src={s2Icon1}
                alt="A diagram showing an integrated Lilly ExploR&D team and Lilly ExploR&D resources, which are clinical operations and medical writing, CMC, transitional medicine, toxicology, DMPK PK/PD, statistics, finance and procurement, quality regulatory that center around a program lead. The team is supported by the other ExploR&D resources, specialty services, CRO/vendors, KOL, CMO."
              />
            </div>
          </div>
        </div>
      ),
    },
  ];
  return (
    <AccordionWrapper
      data={accordionData}
      setOpen={props.setAccordionOpenHeader}
      accordionOpenHeader={props.accordionOpenHeader}
    />
  );
};

export default ProgramManagementAndSupport;
